var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Conversion, Experiment } from './src/index';
function main() {
    var currentUrl = location.pathname;
    var experimentList = JSON.parse(EXPERIMENTS);
    for (var _i = 0, experimentList_1 = experimentList; _i < experimentList_1.length; _i++) {
        var experimentDetails = experimentList_1[_i];
        var conversionData = experimentDetails.conversion, expData = __rest(experimentDetails, ["conversion"]);
        var experiment = new Experiment(expData, currentUrl);
        if (!experiment.shouldRun()) {
            var reason = experiment.getSkipReason() || 'unspecified reason';
            console.info("ABTest: Experiment should not run: ".concat(reason));
            continue;
        }
        ;
        if (expData.isExternal) {
            console.info("ABTest: Landing for external experiment");
        }
        else {
            experiment.run();
        }
        var conversion = new Conversion(conversionData, experiment);
        conversion.enable();
    }
}
;
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        main();
    });
}
else {
    main();
}
document.addEventListener("url-change", function (event) {
    if ('detail' in event) {
        window.detail = event.detail;
    }
    main();
});
